import { gql } from 'graphql-request';

/**
 * The LayoutDefinition selection set. EVERY query that selects a
 * LayoutDefinition must use this fragment rather than picking fields.
 *
 * normy normalizes layout definitions under their `id` (e.g. `printableWeek`),
 * so all queries share one cached layout object. A trimmed selection set writes
 * a partial layout under that key, and normy's mutation diff skips keys the
 * cached object lacks — so a later full response is judged unchanged and never
 * restores them. Every experience query depending on that layout is then
 * denormalized with the partial layout, and consumers read `undefined` from
 * fields their types promise: previewing a layout the cache had never seen in
 * full (change-layout) and confirming it crashed the customize sidebar on
 * `layout.bannerOptions.some` / `layout.eventListDisplayOptions.includes`.
 */
export const LayoutDefinitionFragment = gql`
  fragment LayoutDefinition on LayoutDefinition {
    id
    type
    attributionOptions
    bannerOptions
    blocks {
      layouts
      type
      slots {
        size
      }
    }
    cardOptions {
      layout
      supportsDate
      supportsEmoji
      supportsDescription
      supportsLocation
    }
    eventListDisplayOptions
    heroOptions
    logoOptions
    supportsDescription
  }
`;
